import { OrderItem } from './OrderItem';
import { ConditionItem } from './ConditionItem';
import { SubCondition } from './SubCondition';

export class Condition {
  pageNo: number;
  pageSize: number;
  needTotalCount: boolean;
  OrderItems: Array<OrderItem> = [];
  ConditionItems: Array<ConditionItem> = [];
  SubConditions: Array<SubCondition> = [];
}
